export default "__VITE_ASSET__$BdMFYUt__"